import {BridgeManager} from '@kta20-core/bridge-manager';

//this object is to support the communication
//of kta20 modules and KT1 (if needed).
// @ts-ignore
window.KTA20BridgeManager=BridgeManager.get();